import type { DatadogInterface } from '../shared/datadog';
import { datadogInterface } from '../shared/datadog';
import useAccountModal from '../hooks/useAccountModal';
import type { AuthContextType } from './AuthProvider';
import { useAuth } from './AuthProvider';

type MfeInterface = {
  setUnauthorized: () => void;
  datadog: DatadogInterface;
  useAuth: () => AuthContextType;
  useAccountModal: (
    app: string,
    component: string
  ) => {
    signIn: (handleSuccess?: Function, handleError?: Function) => void;
  };
};

const useMfeInterface = (): MfeInterface => {
  const { setUnauthorized } = useAuth() || {};

  return {
    setUnauthorized: () => {
      setUnauthorized(true);
    },
    datadog: datadogInterface,
    useAccountModal,
    useAuth
  };
};

export default useMfeInterface;
